<template>
  <div>
    <div class="warp clearfix">
      <div id="mp4" class="mp4-area" v-show="mp4Show">
        <div id="coor"></div>
        <div class="mp4-head">
          <span>{{lessonName}}</span>
          <i id="close-mp4" @click="closeMp4" class="iconfont icon-yichu"></i>
        </div>
        <div class="mp4-left">
          <ul>
            <li
              :class="{'play-now': playIndex == index}"
              @click="playVideo(video, index)"
              v-for="(video, index) in lessonInfo.videoList"
              :key="index"
            >
              <b>{{video.fileName}}</b>
              <span></span>
            </li>
          </ul>
        </div>
        <div class="mp4-video">
          <video id="videoElement" ref="video" v-if="videoShow" controls autoplay>
            <source :src="videoSrc" type="video/ogg">
            <source :src="videoSrc" type="video/mp4">
            <object data="movie.mp4" width="320" height="240">
              <embed width="320" height="240" src="movie.swf">
            </object>
          </video>
          <!--     <iframe :src="videoSrc"    ref="video"  id="videoElement"  class="iframe-video" v-if="videoShow"  width="100%" height="100%"  border="0"  frameborder="0"></iframe> -->
        </div>
        <!-- <iframe src="https://www.baidu.com" width="90%" height="90%" frameborder="0"></iframe> -->
      </div>
      <!-- 左侧 -->
      <div id="drag-left" class="left-area">
        <!-- drag -->
        <div id="drag" @mousedown="drag" @mouseup="dragup">
          <!-- drag -->
        </div>
        <!-- tabs -->
        <div class="top-area">
          <div class="tab-area left-tabs left-tabs-js">
            <span
              @click="leftTabChange($event,'file-area')"
              title="file-area"
              class="tab-checked"
            >附件({{attachList.length}})</span>
            <span
              @click="leftTabChange($event,'image-area')"
              title="image-area"
            >影像({{studyList.length}})</span>
            <span @click="leftTabChange($event,'mr-area')" title="mr-area">病例资料({{caseList.length}})</span>
          </div>
        </div>
        <!-- 影像 -->
        <div class="list-area image-area" style="display:none;">
          <div class="list-head" :class="{paddingRight17: isPaddingRight}">
            <span style="width: 20%;">
              <b>检查编号</b>
            </span>
            <span style="width: 20%;">
              <b>性别</b>
            </span>
            <span style="width: 20%;">
              <b>年龄</b>
            </span>
            <span style="width: 20%;">
              <b>类型</b>
            </span>
            <span style="width: 20%;">
              <b>检查项目</b>
            </span>
          </div>

          <p
            v-if="imageList.length == 0"
            style="margin-top: calc((50vh - 128px));text-align:center;"
          >暂无数据</p>
          <ul v-else class="list-body">
            <li
              @click="_getReportInfo(item, index)"
              v-for="(item,index) in imageList"
              :key="index"
              :class="{checked: index == imageListI}"
            >
              <span style="width: 20%;">
                <b>{{item.accessionNumber}}</b>
              </span>
              <span style="width: 20%;">
                <b>{{item.patientSex}}</b>
              </span>
              <span style="width: 20%;">
                <b>{{item.patientAge}}</b>
              </span>
              <span style="width: 20%;">
                <b>{{item.examTypeName}}</b>
              </span>
              <span
                style="width: 20%;overflow: hidden;text-overflow:ellipsis;white-space: nowrap"
                :title="item.examBodyName"
              >
                <b>{{item.examBodyName}}</b>
              </span>
            </li>
          </ul>
        </div>
        <!-- 病例资料 -->
        <div class="list-area mr-area" style="display: none;">
          <div class="list-head" :class="{paddingRight17: isPaddingRight}">
            <span style="width: 40%">
              <b>病例名称</b>
            </span>
            <span style="width: 20%;">
              <b>权限</b>
            </span>
            <span style="width: 20%;">
              <b>性别</b>
            </span>
            <span style="width: 20%;">
              <b>年龄</b>
            </span>
          </div>
          <p
            v-if="dataList.length == 0"
            style="margin-top:calc((50vh - 128px));text-align:center;"
          >暂无数据</p>
          <ul v-else class="list-body">
            <li
              @click="_getMrInfo(item, index)"
              v-for="(item,index) in dataList"
              :key="index"
              :class="{checked: index == mrListI}"
            >
              <span
                style="width: 40%;overflow: hidden;text-overflow:ellipsis;white-space: nowrap"
                :title="item.caseName"
              >
                <b>{{item.caseName}}</b>
              </span>
              <span style="width: 20%;">
                <b>{{item.privateType}}</b>
              </span>
              <span style="width: 20%;">
                <b>{{item.caseSex}}</b>
              </span>
              <span style="width: 20%;">
                <b>{{item.caseAge}}</b>
              </span>
            </li>
          </ul>
        </div>
        <!-- 附件 -->
        <div class="list-area file-area" style="display: block;">
          <div class="file-title">
            <b>1</b> 课件类型
          </div>
          <p
            v-if="fileTypeList.length == 0"
            style="position:relative;top:calc((200px - 64px));text-align:center;min-height: 200px;"
          >暂无数据</p>
          <div v-else class="left-file-content">
            <p
              @click="showFile('file', item, index)"
              v-for="(item,index) in fileTypeList"
              :key="index"
              :class="{'file-checked': index == rightFileIndex}"
            >
              <span>{{item.attach_name}}</span>
            </p>
          </div>
          <div class="file-title">
            <b>2</b> 其他图片
          </div>
          <p
            v-if="filePicList.length == 0"
            style="position:relative;top:calc((200px - 64px));text-align:center;min-height: 200px;"
          >暂无数据</p>
          <div v-else class="left-file-content">
            <p
              @click="showFile('img', item, index)"
              v-for="(item,index) in filePicList"
              :key="index"
              :class="{'file-checked': index == rightPicIndex}"
            >
              <span>{{item.attach_name}}</span>
            </p>
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div id="drag-right" class="right-area">
        <div class="top-area">
          <b style="color:#000;font-weight:blod;font-size:18px;">
            <strong>{{lessonInfo.subject}}</strong>
          </b>
        </div>
        <div class="right-area-inner">
          <!-- 影像 -->
          <div class="right-area-js image-area list-area" style="display: none;">
            <div class="report-area">
              <h3>
                <span style="font-size:16px;font-weight:bold;color:#000">{{examTypeNameres}}报告单</span>
                <span class="rep-button-area">
                  <a
                    class="button btn2"
                    style="background:#898989;"
                    href="javascript:;"
                    @click="getReport"
                  >查看申请单</a>
                  <a class="button btn1" style="background:#898989;" href="javascript:;">电子病历</a>
                  <a
                    @click="getImage()"
                    v-show="readFilmY"
                    class="button btn3"
                    style="padding: 7px 30px;"
                    href="javascript:;"
                  >阅片</a>
                  <a
                    class="button btn4"
                    v-show="readFilmN"
                    style="background:#898989;padding: 7px 30px;"
                    href="javascript:;"
                  >阅片</a>
                </span>
              </h3>
              <div class>
                <report :info="reportInfo"></report>
                <!-- <div class="clearfix">
                                <p class="rep-title none-left-boder">病案号</p>
                                <p class="rep-info-3">受到法律监督上了飞机卡了放假啊快发疯拉</p>
                                <p class="rep-title">门诊号</p>
                                <p class="rep-info-3">10009238</p>
                                <p class="rep-title">住院号</p>
                                <p class="rep-info-3 none-right-boder">10009238</p>
                            </div>
                            <div>
                                <p class="rep-title none-left-boder">就诊医院</p>
                                <p class="rep-info-3">10009238</p>
                                <p class="rep-title">检查类型</p>
                                <p class="rep-info-3">10009238</p>
                                <p class="rep-title">申请医生</p>
                                <p class="rep-info-3 none-right-boder">10009238</p>
                            </div>
                            <div>
                                <p class="rep-title none-left-boder">患者姓名</p>
                                <p class="rep-info-3">10009238</p>
                                <p class="rep-title">年龄</p>p
                                <p class="rep-info-3">10009238</p>
                                <p class="rep-title">性别</p>
                                <p class="rep-info-3 none-right-boder">10009238</p>
                            </div>
                            <div>
                                <p class="rep-title none-left-boder">患者编号</p>
                                <p class="rep-info-3">100923810009238</p>
                                <p class="rep-title">检查编号</p>
                                <p class="rep-info-3">10009238</p>
                                <p class="rep-title">申请科室</p>
                                <p class="rep-info-3 none-right-boder">10009238</p>
                            </div>
                            <div>
                                <p class="rep-title none-left-boder">检查时间</p>
                                <p class="rep-info-3">10009238</p>
                                <p class="rep-title">检查项目</p>
                                <p class="rep-info-3">10009238</p>
                                <p class="rep-title">阴阳性</p>
                                <p class="rep-info-3 none-right-boder">10009238</p>
                            </div>
                            <div>
                                <p class="rep-title none-left-boder">影像所见</p>
                                <p class="rep-info-1 none-right-boder">10009238</p>
                            </div>
                            <div>
                                <p class="rep-title none-left-boder">诊断结果</p>
                                <p class="rep-info-1 none-right-boder">10009238</p>
                            </div>
                            <div>
                                <p class="rep-title none-left-boder">书写医生</p>
                                <p class="rep-info-3">10009238</p>
                                <p class="rep-title">审核时间</p>
                                <p class="rep-info-3">10009238</p>
                                <p class="rep-title">报告时间</p>
                                <p class="rep-info-3 none-right-boder">10009238</p>
                </div>-->
              </div>
            </div>
          </div>
          <!-- 病例资料 -->
          <div class="right-area-js mr-area list-area" style="display: none;">
            <div class="mr-deital-area">
              <!-- tabs -->
              <div class="mr-tabs clearfix">
                <span
                  @click="rightTabChange($event,'mr-info')"
                  title="mr-info"
                  class="mr-tab-checked"
                >病例信息</span>
                <span @click="rightTabChange($event,'mr-img')" title="mr-img">关联影像</span>
                <span @click="rightTabChange($event,'mr-file')" title="mr-file">病例附件</span>
              </div>
              <!-- 病例资料>病例信息 -->
              <div id="mr-info" class="mr-info-content" style="display: block;">
                <h5>| 基本信息</h5>
                <div class="clearfix mr-info-row">
                  <span class="mr-info-title">病例名称：</span>
                  <p class="mr-info-detail-1">{{mrInfo.caseName}}</p>
                </div>
                <div class="clearfix mr-info-row">
                  <span class="mr-info-title">性别：</span>
                  <p class="mr-info-detail">{{mrInfo.caseSex}}</p>
                  <span class="mr-info-title">年龄：</span>
                  <p class="mr-info-detail">
                    <span
                      v-if="mrInfo.caseAge != undefined && mrInfo.caseAge.indexOf('undefined') < 0"
                    >{{mrInfo.caseAge}}</span>
                  </p>
                </div>
                <div class="clearfix mr-info-row">
                  <span class="mr-info-title">创建时间：</span>
                  <p class="mr-info-detail">{{mrInfo.createDate}}</p>
                  <span class="mr-info-title">创建人：</span>
                  <p class="mr-info-detail">{{mrInfo.creatorName}}</p>
                </div>
                <div class="clearfix mr-info-row">
                  <span class="mr-info-title">备注：</span>
                  <p class="mr-info-detail-1">{{mrInfo.remark}}</p>
                </div>
                <h5>| 就诊信息</h5>
                <div class="clearfix mr-info-row">
                  <span class="mr-info-title">病史：</span>
                  <p class="mr-info-detail-1">{{mrInfo.history}}</p>
                </div>
                <div class="clearfix mr-info-row">
                  <span class="mr-info-title">病理结果：</span>
                  <p class="mr-info-detail-1">{{mrInfo.caseResult}}</p>
                </div>
                <div class="clearfix mr-info-row">
                  <span class="mr-info-title">影像所见：</span>
                  <p class="mr-info-detail-1">{{mrInfo.evidence}}</p>
                </div>
                <div class="clearfix mr-info-row">
                  <span class="mr-info-title">诊断结果：</span>
                  <p class="mr-info-detail-1">{{mrInfo.dianogeResult}}</p>
                </div>
              </div>
              <!-- 病例资料>关联影像 -->
              <div id="mr-img" class="mr-info-content" style="display: none;">
                <div class="mr-info-img-list-head">
                  <span style="width:15%;">来源</span>
                  <span style="width:15%;">检查类型</span>
                  <span style="width:20%;">姓名</span>
                  <span style="width:10%;">性别</span>
                  <span style="width:10%;">年龄</span>
                  <span style="width:20%;">检查项目</span>
                  <span style="width:10%;">操作</span>
                </div>
                <p style="text-align:center;" v-if="isNoStudyList">
                  <span style="display:block;margin-top:100px;">
                    <img src="../../../../static/image/defaultpic.png" alt>
                    <span style="display:block;margin-top:20px;text-align:center;">暂无数据</span>
                  </span>
                </p>
                <div v-else class="mr-info-img-list-body">
                  <p
                    v-for="(item, index) in mrInfo.studyList"
                    :key="index"
                    :class="{'background-dark': index%2 == 1}"
                  >
                    <span style="width:15%;" :title="item.hospitalName">{{item.hospitalName}}</span>
                    <span style="width:15%;" :title="item.examTypeName">{{item.examTypeName}}</span>
                    <span style="width:20%;" :title="item.creatorName">{{item.patientName}}</span>
                    <span style="width:10%;" :title="item.patientSex">{{item.patientSex}}</span>
                    <span style="width:10%;" :title="item.patientAge">{{item.patientAge}}</span>
                    <span style="width:20%;" :title="item.examBodyName">{{item.examBodyName}}</span>
                    <span style="width:10%;">
                      <i
                        style="cursor:pointer;"
                        @click="getImage(item)"
                        class="iconfont icon-yuepian"
                        title="阅片"
                      ></i>
                    </span>
                  </p>
                </div>
              </div>
              <!-- 病例资料>病例附件 -->
              <div id="mr-file" class="mr-info-content" style="display: none;">
                <div class="mr-info-file-area clearfix">
                  <span>课件类型：</span>
                  <div class="file-content clearfix">
                    <div class="item-file" v-for="(item,index) in caseTypeList" :key="index">
                      <a :href="caseFileurl">
                        <img :src="item.icon" alt>
                        <p>{{item.attach_name}}</p>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="mr-info-file-area">
                  <span>其他图片：</span>
                  <div class="file-content clearfix">
                    <div class="item-file" v-for="(item,index) in casePicList" :key="index">
                      <img :src="item.fileurl" @click="showBigImg(item.fileurl)" alt>
                      <p>{{item.attach_name}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 附件 -->
          <div class="right-area-js file-area list-area" style="display: block;height:100%">
            <div class="mr-file-area">
              <p v-if="rightFileShow && !rightDownLoadUrl">
                <span style="display:block;margin-top:120px;text-align:center;">
                  <img src="../../../../static/image/defaultpic.png" alt>
                  <!-- <span style="display:block;margin-top:20px;text-align:center;">暂无数据</span>   -->
                </span>
              </p>
              <div v-if="rightFileShow && rightDownLoadUrl" style="width:90%;height:90%">
                <p style="width:400px;text-align:center;margin: 20% auto;">
                  暂不支持预览，请下载附件
                  <br>
                  <br>
                  <a style="margin-top:20px;" :href="rightDownLoadUrl">下载附件</a>
                </p>
                <!-- <iframe v-if="rightFileShow"  ref="iframe" :src="fileUrl" frameborder="0" width="100%" height="100%" ></iframe> -->
              </div>
              <!-- <iframe v-if="rightFileShow" style="display: none;" class="mr-file-iframe" src="" frameborder="0"></iframe> -->
              <img v-if="!rightFileShow" class="mr-pic" :src="rightImgSrc" alt>
            </div>
          </div>
        </div>
        <!-- 工具栏 -->
        <div class="tools-area">
          <div id="open-tool" @click="openTools" v-show="OpenTool" class="open-tools-area">显示工具栏</div>
          <div id="open-tool" @click="openTools" v-show="CloseTool" class="open-tools-area">收起工具栏</div>
          <h2>
            <p
              v-if="oLessonObj.type != 'tenchManage' && lessonInfo.teachType != 2"
              class="time"
            >{{timeStr}}</p>
            <p
              v-if="oLessonObj.type != 'tenchManage' && lessonInfo.teachType == 2"
              class="time"
            >{{timeStr}}</p>
            <p
              v-if="oLessonObj.type == 'tenchManage' && lessonInfo.teachType == 1"
              class="time"
            >{{timeStr}}</p>
            <p
              v-if="oLessonObj.type != 'tenchManage' && lessonInfo.teachType != 2"
              class="time-text"
            >已学习时间</p>
            <p
              v-if="oLessonObj.type != 'tenchManage' && lessonInfo.teachType == 2"
              class="time-text"
            >已学习时间</p>
            <p v-if="oLessonObj.type != '1' && lessonInfo.teachType != '2'" class="time-text">已上课时间</p>
            <!-- 是否是老师{{oLessonObj.type}} <br>
                      教学类型：{{lessonInfo.teachType}}  <br>
            课程状态{{lessonInfo.courseState}} <br>-->
            <!-- 有无视频{{lessonInfo.videoList.length}} -->
            <div>
              <!-- {{oLessonObj.type}}/{{lessonInfo.teachType}} -->
              <!-- 学生 -->
              <a
                class="button button-size-big hover-btn"
                v-if="lessonInfo.courseState == 4 && lessonInfo.teachType == '1' && oLessonObj.type == '1' && lessonInfo.videoList.length == 0"
                href="javascript:void(0);"
                style="background:#898989;"
                id="open-vedio"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-kaiqi"></i> 观看视频
              </a>
              <a
                class="button button-size-big hover-btn"
                v-if="lessonInfo.teachType == '1' && oLessonObj.type == '1' && lessonInfo.videoList.length > 0"
                href="javascript:void(0);"
                @click="openMp4"
                id="open-vedio"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-kaiqi"></i> 观看视频
              </a>
              <a
                class="button button-size-big hover-btn"
                v-if="lessonInfo.courseState != 4 && lessonInfo.teachType == '1' && oLessonObj.type == '1' && lessonInfo.videoList.length == 0"
                href="javascript:void(0);"
                @click="openMp4"
                id="open-vedio"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-kaiqi"></i> 观看视频
              </a>
              <a
                class="button button-size-big hover-btn"
                v-if="lessonInfo.courseState != 4 && lessonInfo.teachType != '1' && oLessonObj.type == '1'"
                href="javascript:void(0);"
                style="background: #898989;"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-kaiqi"></i> 观看视频
              </a>
              <!-- <a class="button button-size-big hover-btn" v-if="oLessonObj.type != '1' && lessonInfo.teachType == '1'" href="javascript:void(0);" @click="openMp4" id="open-vedio" ><i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-kaiqi"></i> 开启视频2</a> -->
              <!-- <a class="button button-size-big" v-if="lessonInfo.teachType == '2' && oLessonObj.type == '1'" style="background:#898989;" href="javascript:void(0);" id="open-vedio" ><i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-kaiqi"></i> 开启视频</a> -->
              <!-- <a class="button button-size-big" v-if="lessonInfo.teachType == '2' && oLessonObj.type == '1'"  href="javascript:void(0);"><i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-kaiqi"></i> 观看视频4</a> -->
              <!-- 老师 -->
              <a
                class="button button-size-big"
                v-if="oLessonObj.type != '1' && lessonInfo.teachType == '1' && lessonInfo.courseState == '4' && lessonInfo.videoList.length == '0'"
                style="background:#898989;"
                href="javascript:void(0);"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-kaiqi"></i> 观看视频
              </a>
              <a
                class="button button-size-big"
                v-if="oLessonObj.type != '1' && lessonInfo.teachType != '1'"
                style="background:#898989;"
                href="javascript:void(0);"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-kaiqi"></i> 开启视频
              </a>
              <a
                class="button button-size-big"
                v-if="oLessonObj.type != '1' && lessonInfo.teachType == '1' && lessonInfo.courseState == '4' && lessonInfo.videoList.length > 0"
                @click="openMp4"
                href="javascript:void(0);"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-kaiqi"></i> 观看视频
              </a>
              <a
                class="button button-size-big"
                v-if="oLessonObj.type != '1' && lessonInfo.teachType == '1' && lessonInfo.courseState != '4'"
                @click="openMp4"
                href="javascript:void(0);"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-kaiqi"></i> 开启视频
              </a>
            </div>
          </h2>
          <div class="lesson-area">
            <p class="clearfix">
              <span class="lesson-title">授课人：</span>
              <span class="lesson-content">{{lessonInfo.teacherName}}</span>
            </p>
            <p class="clearfix">
              <span class="lesson-title">课程时间：</span>
              <span class="lesson-content">{{lessonInfo.courseTime}}</span>
            </p>
            <p class="clearfix">
              <span class="lesson-title">课程分类：</span>
              <span class="lesson-content">{{lessonInfo.courseType}}</span>
            </p>
            <p class="clearfix">
              <span class="lesson-title">学科分类：</span>
              <span class="lesson-content">{{lessonInfo.scienceType || '所有'}}</span>
            </p>
            <p class="clearfix">
              <span class="lesson-title">课程简介：</span>
              <span
                :title="lessonInfo.remark"
                class="lesson-content"
                :class="{'p-line2': line2}"
                style="overflow:hidden;width:140px;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2; "
              >{{lessonInfo.remark}}</span>
            </p>
            <p class="clearfix">
              <span class="lesson-title">最近学员：</span>
              <span class="lesson-content" style="width:120px;">
                <b>{{nowStuList.length}}</b>
                <b>人</b>
                <span
                  v-for="(stu, index) in nowStuList"
                  :title="stu.doctorNeme"
                  :key="index"
                  v-show="index < 5"
                  class="stu-avatar"
                >
                  <img
                    v-if="stu.img==undefined||''"
                    src="../../../../static/image/user.png"
                    class="stu-avatar"
                  >
                  <img v-else :src="stu.img" :onerror="errorImg" class="stu-avatar">
                </span>
              </span>
              <span class="stu-avatar-arrow">＞</span>
            </p>
            <div
              v-if="oLessonObj.type != '1'"
              class="good-area clearfix"
              style="background:rgba(0, 0, 0, 0.3);padding:10px;border-radius:4px;"
            >
              <span class="good-button">
                <i class="iconfont icon-dianzan"></i> 点赞
                <span>{{lessonInfo.goodNum}}</span>
              </span>
              <span class="collect-button">
                <i v-if="collectOperateType == '1'" class="iconfont icon-shoucang"></i>
                <i v-else class="iconfont icon-yishoucang"></i>
                收藏
                <span>{{lessonInfo.collectNum}}</span>
              </span>
            </div>
            <div v-else class="good-area clearfix">
              <a class="good-button" @click="goodLesson" href="javascript:void(0);">
                <i v-if="goodOperateType == '1'" class="iconfont icon-dianzan"></i>
                <i v-else class="iconfont icon-yidianzan"></i>
                点赞
                <span>{{lessonInfo.goodNum}}</span>
                <span v-if="isAdd" class="addgood">+1</span>
              </a>
              <a class="collect-button" @click="collectLesson" href="javascript:void(0);">
                <i v-if="collectOperateType == '1'" class="iconfont icon-shoucang"></i>
                <i v-else class="iconfont icon-yishoucang"></i>
                收藏
                <span>{{lessonInfo.collectNum}}</span>
                <span v-if="isAdd1" class="addgood">+1</span>
              </a>
            </div>
            <!-- 是否是老师{{oLessonObj.type}} <br>
                        教学类型：{{lessonInfo.teachType}}  <br>
            课程状态{{lessonInfo.courseState}} <br>-->
            <div class="ending-study-area">
              <a
                v-if="oLessonObj.type == '1' && this.isEnd"
                class="button button-size-big"
                style="background: #898989;"
                href="javascript:void(0)"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-jieshu"></i>结束学习
              </a>
              <a
                v-if="oLessonObj.type == '1' && !this.isEnd"
                class="button button-size-big"
                @click="endStu('你已完成当前课程了吗？')"
                id="end-study"
                href="javascript:void(0)"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-jieshu"></i>结束学习
              </a>
              <a
                v-if="oLessonObj.type == 'tenchManage' && lessonInfo.teachType == '2' && lessonInfo.courseState == 4"
                class="button button-size-big"
                @click="endStu('您确定要离开当前课程吗？')"
                id="end-study"
                href="javascript:void(0)"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-jieshu"></i>离开课程
              </a>
              <!-- <a v-else class="button button-size-big" @click="endStu" id="end-study" href="javascript:void(0)"><i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-jieshu"></i>结束上课</a> -->
              <!-- 老师 -->
              <a
                v-if="oLessonObj.type != '1' && lessonInfo.teachType == '1' && lessonInfo.courseState == '4'"
                class="button button-size-big"
                @click="endStu('您确定要离开当前课程吗？')"
                id="end-study"
                href="javascript:void(0)"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-jieshu"></i>离开课程
              </a>
              <a
                v-if="oLessonObj.type != '1' && lessonInfo.teachType == '1' && lessonInfo.courseState != '4'"
                class="button button-size-big"
                @click="endStu('您确定要结束当前课程吗？')"
                id="end-study"
                href="javascript:void(0)"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-jieshu"></i>结束课程
              </a>
              <a
                v-if="oLessonObj.type != '1' && lessonInfo.teachType != '1'"
                class="button button-size-big"
                @click="endStu('您确定要离开当前课程吗？')"
                id="end-study"
                href="javascript:void(0)"
              >
                <i style="font-size:12px !important;margin-right:6px;" class="iconfont icon-jieshu"></i>离开课程
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹出申请单 -->
    <pops
      v-if="repShow"
      :show="repShow"
      @closePop="closePop"
      :width="popwidth"
      :title="title"
      :classes="'Collections'"
      class="collect"
    >
      <elcRep :elcRep="elcRep" :emergent="emergent"></elcRep>
    </pops>
    <!-- 图片弹出 -->
    <pops
      v-if="filePop"
      :show="filePop"
      :title="''"
      @closePop="closeFile"
      :class="'mrDialog'"
      :width="'980px'"
    >
      <img :src="url" width="100%" alt>
    </pops>
    <pops :show="fileShow" :title="''" @closePop="closeBigFile" :width="'980px'">
      <iframe :src="Url" frameborder="0" width="100%" height="500px"></iframe>
    </pops>
    <aycanImages
      ref="aycanImages"
      :hospitalId="params_image.hospitalId"
      :studyPk="params_image.studyPk"
      :studyUid="params_image.studyUid"
    ></aycanImages>
  </div>
</template>

<script>
import * as _ from "@/common/js/config";
import http from "@/api/http";
import { nomalTime, nomalTimes } from "@/common/js/time";
import { message } from "@/common/js/messages";
import elcRep from "@/components/common/report/electronicReport";
import pops from "@/components/common/pops/pop";
import report from "@/components/common/report/publicReport";
import {
  changehosArea,
  changeAge,
  changeGender,
  changeSex,
  yinyang,
  changeclinicType
} from "@/common/js/change";
import { mapMutations } from "vuex";

import aycanImages from "@/components/common/base/aycanImages";
import { setTimeout } from "timers";
export default {
  components: {
    elcRep,
    report,
    pops,
    aycanImages
  },
  watch: {
    lessonState(c, o) {
      if (!o) {
        return false;
      }
      if (!c) {
        alert("课程已结束，接下来是您的自由学习时间。");
      }
    }
  },
  data() {
    return {
      elcRep: {},
      emergent: false,
      repShow: false,
      popwidth: "80%",
      //以上为申请单所需参数
      isNoStudyList: true, //病例资料·>关联影像是否有数据
      leftH: 0, //左侧样式对齐
      isPaddingRight: false, //左侧样式对齐右padding标示
      line2: false, //控制样式
      lessonState: false, //课程状态心跳接口 false =》结束
      firstAlert: false, //第一次弹出
      heartbeatFlag: 0, //心跳
      loading: false,
      userName: "", //用户名
      rightFileIndex: "-1",
      rightPicIndex: "-1",
      filurl: "", //病例文件附件url
      title: "",
      videoSrc: "", //播放的src地址
      aycanParams: {
        hospitalId: "",
        studyPk: "",
        studyUid: ""
      }, //阅片
      url: "", //大图预览的路径
      fileUrl: "", //文件预览路径
      filePop: false,
      fileShow: false,
      examTypeNameres: "",
      goodOperateType: 1, //点赞操作类型
      collectOperateType: 1, //收藏操作类型
      isEnd: false, //是否结束学习
      stuTime: 0, //学习时间
      timeStr: "", //学习时间
      classId: "", //课堂id
      rightDownLoadUrl: "",
      rightImgSrc: "",
      rightFileShow: true,
      leftTabsCheck: "file-area",
      mrListI: "",
      readFilmY: false, //阅片按钮是否可以点击
      readFilmN: true, //阅片按钮是否可以点击
      imageListI: "",
      mrInfo: {}, // 病例数据
      reportInfo: {}, // 报告单数据
      lessonInfo: {}, // 课程详情
      mp4Show: false,
      videoShow: false,
      examTypeName: "", //影像类型
      lessonName: "",
      endStudyAlert: true, //弹出控制
      bIsOpenTool: true,
      bIsResizing: false,
      isAdd: false, //点赞添加
      isAdd1: false, //收藏添加
      nLastDownX: 0,
      caseList: 0, //病例资料数量
      attachList: 0, //附件数量
      studyList: 0, //影像的数量
      token: "", //视频token
      playIndex: 0,
      url: "",
      Url: "", //病例附件的文件url
      imageList: [], //影像列表
      fileList: [], //附件列表
      filePicList: [], //附件图片类型列表
      fileTypeList: [], //附件文件列表
      caseTypeList: [], //病例附件文件列表
      caseFileurl: "", //病例附件文件url
      casePicList: [], //病例附件图片类型列表
      nowStuList: [], //当前学员列表
      CloseTool: false, //工具栏收起
      OpenTool: true, //工具栏打开
      errorImg: 'this.src="' + require("@/assets/images/errorimg.png") + '"', //图片错误
      dataList: [], //病例列表
      params_image: {
        //阅片数据
        hospitalId: "",
        studyPk: "",
        studyUid: ""
      },
      check_applicat: {
        //查看申请单
        hospitalId: "",
        studyPk: 0,
        studyUid: ""
      },
      videoStart: {
        hospitalId: "",
        studyPk: "",
        studyUid: ""
      }
    };
  },
  methods: {
    getImage(item) {
      if (item) {
        this.params_image.hospitalId = item.hospitalId;
        this.params_image.studyPk = item.studyPk;
        this.params_image.studyUid = item.studyUid;
        // this.aycanParams = {
        //   hospitalId:item.hospitalId,
        //   studyPk:item.studyPk,
        //   studyUid:item.studyUid,
        // }
      } else {
        if (!this.params.hospitalId) {
          message("请选择报告单", false);
          return;
        } else {
          this.params_image.hospitalId = this.params.hospitalId;
          this.params_image.studyPk = this.params.studyPk + "";
          this.params_image.studyUid = this.params.studyUid;
          // this.aycanParams = {
          //   hospitalId:this.params.hospitalId,
          //   studyPk:this.params.studyPk,
          //   studyUid:this.params.studyUid,
          // }
        }
      }

      this.$nextTick(() => {
        this.$refs.aycanImages.getConsultImages();
      });
      // http.post('/edu/prepareAycan.json', this.aycanParams).then(res => {
      //   if (res.data.code === "0000") {
      //     let url = res.data.model
      //     window.open(url,'_blank')
      //   }else{
      //     message(res.data.msg,false)
      //   }
      //   this.aycanParams = {
      //     hospitalId:'',
      //     studyPk:'',
      //     studyUid:'',
      //   }
      // }).catch(() => {
      // })
    },

    closePop(val) {
      this.repShow = false;
    },
    showBigImg(url) {
      this.filePop = true;
      this.url = url;
    },
    showBigFile(url) {
      this.fileShow = true;
    },
    closeFile(val) {
      this.filePop = false;
    },
    closeBigFile(val) {
      this.fileShow = false;
    },
    closeMp4() {
      this.mp4Show = false;
      this.videoShow = false;
    },
    openMp4() {
      if (this.lessonInfo.teachType == "1") {
        if (
          this.lessonInfo.videoList.length > 0 &&
          this.lessonInfo.courseState == 4
        ) {
          this.mp4Show = true;
          this.videoSrc = this.lessonInfo.videoList[0].uri;
          //this.videoSrc= this.lessonInfo.videoList[0].playurl
          this.videoShow = true;
        } else {
          alert("客户端正在启动，请稍候");
          // 直播授课
          let startViewJson = {
            id: this.lessonInfo.confId
          };
          http
            .post("/conference/startDailyConfView.json", startViewJson)
            .then(res => {
              if (res.data.code === "SUCCESS") {
                // console.log(this.userName)
                let txtServerAddress = "114.55.29.216"; //服务器地址
                let txtServerPort = "17979"; //服务器端口
                let txtUserNickname = this.userName; //用户昵称
                let txtQuickUserID = "110"; //用户ID
                let txtQuickConfID = res.data.model.confId; //会议ID
                let txtUserRole = "1"; //会议角色
                let txtQuickToken = this.token; //Token
                let txtQuickrecordId = this.lessonInfo.confId; //会诊ID
                let txtQuickAddress = window.videoUrl; //HTTP Server  //http://60.190.245.75:8080
                let txtQuickRequest = "/edu_web/video/videoRecodesave.json"; //请求方法

                if (this.oLessonObj.type == 1) {
                  txtQuickAddress = "";
                  txtQuickRequest = "";
                }
                //alert('txtQuickAddress:'+txtQuickAddress)
                //alert('txtQuickRequest:'+txtQuickRequest)

                let jsonText = this.getJsonTextQuickEnterConf(
                  txtServerAddress,
                  txtServerPort,
                  txtUserNickname,
                  txtQuickUserID,
                  txtQuickConfID,
                  txtUserRole,
                  txtQuickToken,
                  txtQuickrecordId,
                  txtQuickAddress,
                  txtQuickRequest
                );
                // alert(jsonText)
                let jsonTextBase64 = this.base64encode(this.utf16to8(jsonText));
                this.executeAction(jsonTextBase64);
              } else {
                message(res.data.msg, false);
              }
            })
            .catch(() => {});
        }
      } else {
        // 自主学习
        return false;
      }
    },
    playVideo(vedio, index) {
      this.videoSrc = vedio.uri;
      //this.videoSrc= this.lessonInfo.videoList[0].playurl
      // console.log(this.$refs.video)
      this.playIndex = index;
      this.$refs.video.src = vedio.playurl;
      //let el = document.getElementById('videoElement')
      //el.play()
    },
    dragup() {
      this.bIsResizing = false;
    },
    getLessonId() {
      http
        .post("/studyCenter/startLearnCourse.json", {
          courseId: this.oLessonObj.lessonId
        })
        .then(res => {
          if (res.data.code == "SUCCESS") {
            this.classId = res.data.model;
            this.getTime();
          } else {
            message("该条数据没有报告单", false);
          }
        });
    },
    goodLesson() {
      http
        .post("/studyCenter/appreciateCourse.json", {
          courseId: this.oLessonObj.lessonId,
          operateType: this.goodOperateType
        })
        .then(res => {
          if (res.data.code === "SUCCESS") {
            if (this.goodOperateType == 0) {
              this.goodOperateType = 1;
              this.lessonInfo.goodNum = this.lessonInfo.goodNum - 1;
              this.isAdd = false;
            } else {
              this.goodOperateType = 0;
              this.lessonInfo.goodNum = this.lessonInfo.goodNum - 0 + 1;
              this.isAdd = true;
            }
          } else {
          }
        })
        .catch(err => {});
    },
    collectLesson() {
      http
        .post("/studyCenter/collectCourse.json", {
          courseId: this.oLessonObj.lessonId,
          operateType: this.collectOperateType
        })
        .then(res => {
          if (res.data.code === "SUCCESS") {
            if (this.collectOperateType == 0) {
              this.collectOperateType = 1;
              this.lessonInfo.collectNum = this.lessonInfo.collectNum - 1;
              this.isAdd1 = false;
            } else {
              this.collectOperateType = 0;
              this.lessonInfo.collectNum = this.lessonInfo.collectNum - 0 + 1;
              this.isAdd1 = true;
            }
          } else {
          }
        })
        .catch(err => {});
    },
    // 实时获取学生头像
    getNowStuAvatar() {
      if (this.oLessonObj.type == "tenchManage") {
        this.heartbeatFlag = 1;
      }
      // alert(this.heartbeatFlag)
      http
        .post("/course/studentList.json", {
          Id: this.oLessonObj.lessonId,
          lessonId: this.classId,
          flag: this.heartbeatFlag
        })
        .then(res => {
          // alert(res.data.code)
          if (res.data.code == "SUCCESS") {
            this.nowStuList = res.data.model.user;
            this.lessonState = res.data.model.state;
            if (!res.data.model.state || this.isEnd) {
              if (this.lessonInfo.courseState == 4 && this.firstAlert) {
                this.endStudyAlert = false;
              } else {
                this.endStudyAlert = true;
              }
              if (!this.endStudyAlert && this.oLessonObj.type == "1") {
                // alert('课程已结束，接下来是您的自由学习时间。')
                this.endStudyAlert = true;
              }
              return false;
            }
            setTimeout(this.getNowStuAvatar, 10000);
          } else {
            message("该条数据没有报告单", false);
          }
        });
      // 获取点赞，收藏数量
      http
        .post("/course/collectAndGood.json", {
          id: this.oLessonObj.lessonId
        })
        .then(res => {
          if (res.data.code == "SUCCESS") {
            this.lessonInfo.goodNum = res.data.model.goodNum;
            this.lessonInfo.collectNum = res.data.model.collectNum;
            if (res.data.model.collectFlag == 1) {
              this.collectOperateType = 0;
            } else {
              this.collectOperateType = 1;
            }
            if (res.data.model.appreciateFlag == 1) {
              this.goodOperateType = 0;
            } else {
              this.goodOperateType = 1;
            }
          } else {
            message("该条数据没有报告单", false);
          }
        });
    },
    drag() {
      this.bIsResizing = true;
      let nLastDownX = event.clientX;
      let oLeft = document.getElementById("drag-left"),
        nLeftWidth = oLeft.clientWidth,
        oRight = document.getElementById("drag-right"),
        nRightWidth = oRight.clientWidth,
        nWidth = document.body.clientWidth;
      if (this.bIsResizing) {
        let that = this;
        // 拖拽
        document.onmousemove = function() {
          if (!that.bIsResizing) return false;
          var nNewWidth = nLeftWidth - (nLastDownX - event.clientX);
          // console.log(nLeftWidth)
          if (nNewWidth > nWidth / 2) {
            nNewWidth = nWidth / 2 - 4;
            that.bIsResizing = false;
            return false;
          } else if (nNewWidth < 250) {
            nNewWidth = 252;
            that.bIsResizing = false;
            return false;
          }
          oLeft.style.width = nNewWidth + "px";
          oRight.style.width = nWidth - nNewWidth + "px";
        };
      } else {
        return false;
      }
      document.onmouseup = function() {
        let that = this;
        that.bIsResizing = false;
      };
    },
    init() {
      let [aHref, oLessonObj] = [window.location.href.split("&"), {}];
      for (var i = 1; i < aHref.length; i++) {
        var arr = aHref[i].split("=");
        oLessonObj[arr[0]] = arr[1];
      }
      this.oLessonObj = oLessonObj;
      if (oLessonObj.type == 1) {
        // 学生
        this.getLessonId();
        // this.computedTime()
      } else {
        // 老师
        this.startLesson();
        this.getNowStuAvatar();
      }
      this.getImageList();
    },
    startLesson() {
      http
        .post("/course/comingCourse.json", {
          Id: this.oLessonObj.lessonId
        })
        .then(res => {
          if (res.data.code == "SUCCESS") {
            // console.log(res)
            // this.classId = res.data.model
            // console.log(new Date().getTime() + 'now')
            // console.log(res.data.model)
            this.stuTime = (res.data.model / 1000) | 0 || 0;
            this.computedTime();
            this.getNowStuAvatar();
          } else {
            message("该条数据没有报告单", false);
          }
        });
    },
    //病例资料列表
    _getMrInfo(item, index) {
      this.mrListI = index;
      let params = {
        id: item.id
      };
      http.post("/caselib/getCaseDetail.json", params).then(res => {
        if (res.data.code == "SUCCESS") {
          this.mrInfo = res.data.model;
          this.mrInfo.createDate = nomalTime(this.mrInfo.createDate);
          if (this.mrInfo.studyList.length > 0) {
            this.isNoStudyList = false;
          } else {
            this.isNoStudyList = true;
          }
          this.mrInfo.caseSex == 1
            ? (this.mrInfo.caseSex = "男")
            : (this.mrInfo.caseSex = "女");
          if (this.mrInfo.ageUnit == 4) {
            this.mrInfo.caseAge += "岁";
          } else if (this.mrInfo.ageUnit == 3) {
            this.mrInfo.caseAge += "月";
          } else if (this.mrInfo.ageUnit == 2) {
            this.mrInfo.caseAge += "周";
          } else if (this.mrInfo.ageUnit == 1) {
            this.mrInfo.caseAge += "天";
          } else {
            this.mrInfo.caseAge += "小时";
          }
          for (let item of this.mrInfo.studyList) {
            item.patientSex == "M"
              ? (item.patientSex = "男")
              : (item.patientSex = "女");
            //item.hosArea == '0' ? item.hosArea = '解放院区' : item.hosArea = '滨江院区'
            /*  if (item.patientAge) {
                  if (item.ageUnit == 4) {
                    item.patientAge += '岁'
                  } else if (item.ageUnit == 3) {
                    item.patientAge += '月'
                  } else if (item.ageUnit == 2) {
                    item.patientAge += '周'
                  } else if (item.ageUnit == 1) {
                    item.patientAge += '天'
                  } else {
                    item.patientAge += ''
                  }
               } else {
                 item.patientAge = ''
               } */
            if (item.patientAge == undefined) {
              item.patientAge = "";
            } else if (item.patientAge.indexOf("岁") > 0) {
              item.patientAge = item.patientAge;
            } else {
              item.patientAge = item.patientAge + changeAge(item.ageUnit);
            }
          }
          // this.fileTypeList = []
          // this.filePicList = []
          this.caseTypeList = [];
          this.casePicList = [];
          // 判断类型
          for (let item of this.mrInfo.attachList) {
            if (item.attach_type == "file") {
              let icon = item.attach_name.substring(
                item.attach_name.lastIndexOf(".") + 1
              );
              if (icon == "xls" || icon === "xlsx") {
                //判断类型显示图标
                item.icon = "./static/image/xlsicon.png";
              } else if (icon == "doc" || icon == "rtf" || icon == "docx") {
                item.icon = "./static/image/docicon.png";
              } else if (icon == "pdf") {
                item.icon = "./static/image/pdficon.png";
              } else if (icon == "ppt" || icon == "pptx") {
                item.icon = "./static/image/ppticon.png";
              } else {
                item.url = res.data.model.filePathUrl;
              }
              this.caseTypeList.push(item);
              this.caseFileurl = encodeURI(encodeURI(item.fileurl));
              // console.log(item.attach_name,'111')
              // this.Url =encodeURI(`http://ow365.cn/?i=17666&ssl=1&furl=${item.fileurl}`)
              // this.fileTypeList.push(item)
            } else {
              this.casePicList.push(item);
              // this.filePicList.push(item)
            }
          }
        } else {
          message(res.data.msg, false);
        }
      });
    },
    _getUserInfo() {
      // 获取用户个人信息
      http
        .post("/getUserInfo.json")
        .then(res => {
          if (res.data.code === _.ERR_OK) {
            // console.log(res.data.model)
            this.userName = res.data.model.userName;
          } else {
          }
        })
        .catch(err => {});
    },

    _getReportInfo(item, index) {
      debugger;
      this.check_applicat = item;
      this.imageListI = index;
      this.reportInfo = {};
      this.elcRep = item;
      let params = {
        hospitalId: item.hospitalId,
        studyPk: item.studyPk,
        studyUid: item.studyUid
      };
      this.params = params;
      this.readFilmY = true;
      this.readFilmN = false;
      if (item.reportState != 3) {
        this.$message({
          message: "该影像没有报告单",
          type: "error",
          duration: 1000
        });
        return false;
      }
      http.post("/edu/reportDetail.json", params).then(res => {
        if (res.data.code == "0000") {
          res.data.model.masculineFlag = yinyang(res.data.model.masculineFlag);
          res.data.model.patientSex = changeGender(res.data.model.patientSex);
          res.data.model.studiesDoneDt = nomalTime(
            res.data.model.studiesDoneDt
          );
          res.data.model.reportSdt = nomalTime(res.data.model.reportSdt);
          res.data.model.approveDt = nomalTime(res.data.model.approveDt);
          res.data.model.clinicType = changeclinicType(
            res.data.model.clinicType
          );
          this.examTypeNameres = res.data.model.examTypeName;

          if (res.data.model.patientAge == undefined) {
            res.data.model.patientAge = "";
          } else if (res.data.model.patientAge.indexOf("岁") > 0) {
            res.data.model.patientAge = res.data.model.patientAge;
          } else {
            res.data.model.patientAge =
              res.data.model.patientAge + changeAge(res.data.model.ageUnit);
          }
          this.reportInfo = res.data.model;
        } else {
          this.$message({
            message: "该条数据没有报告单",
            type: "error",
            duration: 1000
          });
        }
      });
      item.auditDate = nomalTime(item.auditDate);
      item.examDate = nomalTime(item.examDate);
    },
    //查看电子申请单
    getReport(item, index) {
      return;
    },
    openTools() {
      this.bIsOpenTool = !this.bIsOpenTool;
      this.CloseTool = true;
      // if (this.oIsOpenTool) {
      //     this.bIsOpenTool=true,
      //     this.innerHTML = '收起工具栏'
      // } else {
      //     this.innerHTML = '显示工具栏'
      // }
      var oTool = document.getElementsByClassName("tools-area")[0];
      var nPos = parseFloat(
        oTool.style.right || getComputedStyle(oTool, false).right
      );
      if (nPos === 0) {
        this.CloseTool = false;
      }
      var timer = setInterval(function() {
        var l = parseFloat(
          oTool.style.right || getComputedStyle(oTool, false).right
        );
        l = l < -240 ? 0 : l;
        if (nPos === 0) {
          oTool.style.right = l - 4 + "px";
          if (l < -232) {
            clearInterval(timer);
          }
        } else {
          if (l > -8) {
            clearInterval(timer);
          }
          oTool.style.right = l + 4 + "px";
        }
      }, 1);
    },
    // 左侧tabs切换
    leftTabChange(event, tabs) {
      if (this.leftTabsCheck === tabs) {
        return false;
      }
      this.isPaddingRight = false;
      this.leftTabsCheck = tabs;
      let spans = document.getElementsByClassName("left-tabs")[0].childNodes;
      for (let item of spans) {
        item.className = " ";
      }
      if (event.target.title === tabs) {
        event.target.className = "tab-checked";
      }
      let aAreas = document.getElementsByClassName("list-area");
      for (let item of aAreas) {
        item.style.display = "none";
      }
      var ele = document.getElementsByClassName(tabs)[0];
      var ele1 = document.getElementsByClassName(tabs)[1];
      ele.style.display = "block";
      ele1.style.display = "block";
      if (tabs == "file-area") {
        this.getFileList();
      } else if (tabs == "mr-area") {
        this.getDataList();
      } else {
        this.getImageList();
      }
    },
    getImageList(val) {
      http
        .post("/system/getRelateStudyList.json", {
          refId: this.oLessonObj.lessonId,
          businessType: "course"
        })

        .then(res => {
          if (res.data.code === _.ERR_OK) {
            this.imageList = res.data.model;
            for (let index = 0; index < this.imageList.length; index++) {
              this.aycanParams.hospitalId = this.imageList[index].hospitalId;
              this.aycanParams.studyPk = this.imageList[index].studyPk;
              this.aycanParams.studyUid = this.imageList[index].studyUid;
            }
            if (this.imageList.length * 34 > this.leftH) {
              this.isPaddingRight = true;
            }
            this._getReportInfo();
            for (let item of this.imageList) {
              if (item.patientSex === "M") {
                item.patientSex = "男";
              } else {
                item.patientSex = "女";
              }
              /*   if (item.ageUnit == 4) {
                item.patientAge += '岁'
              } else if (item.ageUnit == 3) {
                item.patientAge += '月'
              } else if (item.ageUnit == 2) {
                item.patientAge += '周'
              } else if (item.ageUnit == 1) {
                item.patientAge += '天'
              } else {
                item.patientAge += '小时'
              } */
            }
          } else {
          }
        })
        .catch(err => {});
    },
    getDataList() {
      http
        .post("/system/getRelateCaseList.json", {
          refId: this.oLessonObj.lessonId,
          businessType: "course"
        })
        .then(res => {
          if (res.data.code === _.ERR_OK) {
            this.dataList = res.data.model;
            if (this.dataList.length * 34 > this.leftH) {
              this.isPaddingRight = true;
            }
            this._getMrInfo(this.dataList[0], 0);
            for (let item of this.dataList) {
              if (item.caseSex == "1") {
                item.caseSex = "男";
              } else {
                item.caseSex = "女";
              }
              if (item.caseAge) {
                if (item.ageUnit == 4) {
                  item.caseAge += "岁";
                } else if (item.ageUnit == 3) {
                  item.caseAge += "月";
                } else if (item.ageUnit == 2) {
                  item.caseAge += "周";
                } else if (item.ageUnit == 1) {
                  item.caseAge += "天";
                } else {
                  item.caseAge += "小时";
                }
              } else {
                item.caseAge = "";
              }
              if (item.privateType == 0) {
                item.privateType = "公共";
              } else if (item.privateType == 1) {
                item.privateType = "私有";
              } else if (item.privateType == 2) {
                item.privateType = "部门公开";
              } else if (item.privateType == 3) {
                item.privateType = "医院公开";
              }
            }
          } else {
          }
        })
        .catch(err => {});
    },
    getFileList() {
      http
        .post("/system/getRelateAttachList.json", {
          refId: this.oLessonObj.lessonId,
          businessType: "course"
        })
        .then(res => {
          if (res.data.code === _.ERR_OK) {
            this.fileTypeList = [];
            this.filePicList = [];
            this.fileList = res.data.model;
            // 判断类型
            for (let item of this.fileList) {
              if (item.attach_type == "file") {
                this.fileTypeList.push(item);
              } else {
                this.filePicList.push(item);
              }
            }
          } else {
          }
        })
        .catch(err => {});
    },
    rightTabChange(event, tabs) {
      let spans = document.getElementsByClassName("mr-tabs")[0].childNodes;
      for (let item of spans) {
        item.className = " ";
      }
      if (event.target.title === tabs) {
        event.target.className = "mr-tab-checked";
      }
      let aAreas = document.getElementsByClassName("mr-info-content");
      for (let item of aAreas) {
        item.style.display = "none";
      }
      var ele = document.getElementById(tabs);
      ele.style.display = "block";
    },
    // 获取时间==学生
    getTime() {
      // alert(this.oLessonObj.lesfsonId)
      http
        .post("/studyCenter/getAllTimeStudy.json", {
          courseId: this.oLessonObj.lessonId
        })
        .then(res => {
          if (res.data.code === "SUCCESS") {
            this.stuTime = res.data.model.timeLen;
            if (res.data.model.operateCode == "n") {
              this.isEnd = false;
              this.heartbeatFlag = 0;
            } else {
              this.isEnd = true;
              this.heartbeatFlag = 1;
            }
            this.computedTime();
            this.getNowStuAvatar();
            // this.lessonName = res.data.model.subject
          } else {
          }
        })
        .catch(err => {});
    },

    endStu(msg) {
      // let msg = this.oLessonObj.type == 1 ?　'你已完成当前课程了吗？' :　'确定要结束当前课程吗?'
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        this.heartbeatFlag = 1;
        if (this.oLessonObj.type == 1) {
          if (this.isEnd) {
            return false;
          }
          // 学生
          http
            .post("/studyCenter/endLearnCourse.json", {
              lessonId: this.classId
            })
            .then(res => {
              if (res.data.code === "SUCCESS") {
                if (res.data.msg === "操作成功") {
                  this.isEnd = true;
                  this.endStudyAlert = false;
                  this.getNowStuAvatar();
                }
              } else {
              }
            })
            .catch(err => {});
        } else {
          // 老师
          http
            .post("/course/endCourse.json", {
              Id: this.oLessonObj.lessonId
            })
            .then(res => {
              // alert(res.data.code)
              if (res.data.code === "SUCCESS") {
                if (res.data.msg === "成功") {
                  this.isEnd = true;
                  this.$message({
                    message: "结束课程成功",
                    type: "success",
                    duration: 1000
                  });
                  this.getNowStuAvatar();
                  window.close();
                } else {
                  if (this.lessonInfo.courseState == 4) {
                    window.close();
                  } else {
                    window.close();
                    // alert(res.data.msg)
                  }
                }
              } else {
              }
            })
            .catch(err => {});
        }
      });
    },
    computedTime() {
      // alert(this.stuTime)
      this.stuTime++;
      var hours =
        Math.floor(this.stuTime / 3600) < 10
          ? "0" + Math.floor(this.stuTime / 3600)
          : Math.floor(this.stuTime / 3600);
      var minutes =
        Math.floor((this.stuTime - hours * 3600) / 60) < 10
          ? "0" + Math.floor((this.stuTime - hours * 3600) / 60)
          : Math.floor((this.stuTime - hours * 3600) / 60);
      var seconds =
        this.stuTime - hours * 3600 - minutes * 60 < 10
          ? "0" + (this.stuTime - hours * 3600 - minutes * 60)
          : this.stuTime - hours * 3600 - minutes * 60;
      this.timeStr = `${hours}:${minutes}:${seconds}`;
      if (!this.isEnd) {
        setTimeout(this.computedTime, 1000);
      }
    },
    getLessonInfo() {
      http
        .post("/course/getCourseDetail.json", {
          id: this.oLessonObj.lessonId
        })
        .then(res => {
          if (res.data.code === _.ERR_OK) {
            // console.log(res)
            this.lessonInfo = res.data.model;
            this.attachList = res.data.model.attachList;
            this.caseList = res.data.model.caseList;
            this.studyList = res.data.model.studyList;
            this.lessonInfo.videoList = res.data.model.videoList || [];
            this.lessonInfo.remark = res.data.model.remark || " ";
            if (this.lessonInfo.remark.length > 30) {
              this.line2 = true;
            }
            if (this.lessonInfo.teachType == 2) {
              this.lessonInfo.courseTime = "永久";
            } else {
              this.lessonInfo.courseTime = nomalTime(
                this.lessonInfo.courseTime
              );
            }
            // this.lessonInfo.courseTime = nomalTime(this.lessonInfo.courseTime)
            if (this.lessonInfo.videoList.length > 0) {
              this.videoSrc = "";
            }
            if (this.lessonInfo.courseState == 4) {
              this.isEnd = true;
            } else {
              this.isEnd = false;
            }
          } else {
          }
        })
        .catch(err => {});
    },
    showFile(type, item, index) {
      this.rightFileIndex = "-1";
      this.rightPicIndex = "-1";
      if (type === "img") {
        this.rightImgSrc = item.fileurl;
        this.rightFileShow = false;
        this.rightPicIndex = index;
      } else {
        this.rightDownLoadUrl = encodeURI(encodeURI(item.fileurl));
        this.rightFileShow = true;

        this.rightFileIndex = index;
      }
    },
    // 沪市
    getJsonTextQuickEnterConf(
      serverAddress,
      serverPort,
      userNickname,
      userID,
      confID,
      UserRole,
      token,
      recordId,
      address,
      request
    ) {
      var jsonText =
        "{" +
        '"Server": {' +
        '"Address": "' +
        serverAddress +
        '",' +
        '"Port": ' +
        serverPort +
        "}," +
        '"Action": {' +
        '"Name": "QuickEnterConf",' +
        '"Parameters": {' +
        '"UserName": "' +
        this.encodeUTF8(userNickname) +
        '"' +
        ',"UserID": ' +
        userID +
        ',"ConfID": ' +
        confID +
        ',"UserRole": ' +
        UserRole +
        "," +
        '"Token": "' +
        token +
        '",' +
        '"RecordId": "' +
        recordId +
        '",' +
        '"Address": "' +
        address +
        '",' +
        '"Request": "' +
        request +
        '"' +
        "}" +
        "}" +
        "}";
      return jsonText;
    },
    encodeUTF8(str) {
      var temp = "",
        rs = "";
      for (var i = 0, len = str.length; i < len; i++) {
        temp = str.charCodeAt(i).toString(16);
        rs += "\\u" + new Array(5 - temp.length).join("0") + temp;
      }
      return rs;
    },
    utf16to8(str) {
      var out, i, len, c;

      out = "";
      len = str.length;
      for (i = 0; i < len; i++) {
        c = str.charCodeAt(i);
        if (c >= 0x0001 && c <= 0x007f) {
          out += str.charAt(i);
        } else if (c > 0x07ff) {
          out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f));
          out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f));
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
        } else {
          out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f));
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
        }
      }
      return out;
    },
    base64encode(str) {
      var base64EncodeChars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      var out, i, len;
      var c1, c2, c3;

      len = str.length;
      i = 0;
      out = "";
      while (i < len) {
        c1 = str.charCodeAt(i++) & 0xff;
        if (i == len) {
          out += base64EncodeChars.charAt(c1 >> 2);
          out += base64EncodeChars.charAt((c1 & 0x3) << 4);
          out += "==";
          break;
        }
        c2 = str.charCodeAt(i++);
        if (i == len) {
          out += base64EncodeChars.charAt(c1 >> 2);
          out += base64EncodeChars.charAt(
            ((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4)
          );
          out += base64EncodeChars.charAt((c2 & 0xf) << 2);
          out += "=";
          break;
        }
        c3 = str.charCodeAt(i++);
        out += base64EncodeChars.charAt(c1 >> 2);
        out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
        out += base64EncodeChars.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6));
        out += base64EncodeChars.charAt(c3 & 0x3f);
      }
      return out;
    },
    executeAction(jsonTextBase64) {
      var theResult = -1;
      $.ajax({
        type: "GET",
        url: "http://127.0.0.1:17979/IMConf",
        data: "URL=IMConf://" + jsonTextBase64 + "/",
        dataType: "jsonp",
        //async: false,
        jsonp: "jsonpCallback",
        success: function(data) {
          theResult = 0;
          if (data.result != 0) {
            // console.log('成功啦')
            message(data.message);
          }
        },
        error: function() {
          theResult = 0;
          // alert("ajax error!");
        }
      });

      setTimeout(function() {
        if (theResult != 0) {
          alert("客户端软件未安装或者被破坏！");
        }
      }, 500);
    },
    getCookie(name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return "";
    },
    ...mapMutations({
      isCollect: "ISCOLLECT"
    })
  },
  created() {
    this.init();
    this.getFileList();
    this.getLessonInfo();
    this._getUserInfo();
    this.token = this.getCookie("eimageglobaltid");
  },
  mounted() {
    this.getFileList();
    this.getLessonInfo();
    this.leftH = document.body.clientHeight - 104;
  },
  beforeDestroy() {}
};
</script>

<style scoped>
html,
body,
div,
span,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
abbr,
address,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
samp,
small,
strong,
sub,
sup,
var,
b,
i,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  box-sizing: border-box;
}

body {
  line-height: 1;
  font-size: 14px;
}

:focus {
  outline: 1;
}

a {
  text-decoration: none;
}

ul {
  list-style: none;
}

article,
aside,
canvas,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
summary {
  display: block;
}

nav ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

a {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
}

ins {
  background-color: #ff9;
  color: #000;
  text-decoration: none;
}

mark {
  background-color: #ff9;
  color: #000;
  font-style: italic;
  font-weight: bold;
}

del {
  text-decoration: line-through;
}

abbr[title],
dfn[title] {
  border-bottom: 1px dotted #000;
  cursor: help;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #cccccc;
  margin: 1em 0;
  padding: 0;
}

input,
select {
  vertical-align: middle;
}

.clearfix {
  *zoom: 1;
}

.clearfix:before,
.clearfix:after {
  display: table;
  line-height: 0;
  content: "";
}

.clearfix:after {
  clear: both;
}

.warp {
  min-width: 1200px;
  width: 100%;
  height: 100vh;
  min-height: 670px;
  overflow: hidden;
}
.hover-btn:hover {
  background: #00cece;
}
.addgood {
  position: absolute;
  left: 54px;
  animation: mymove 2s forwards;
}
@keyframes mymove {
  from {
    top: 0px;
    left: 54px;
    opacity: 1;
  }
  to {
    top: -10px;
    left: 54px;
    opacity: 0;
  }
}

/* 拖动 */

#drag {
  cursor: w-resize;
  width: 4px;
  position: absolute;
  top: 0;
  height: 100%;
  right: -4px;
  background: transparent;
}

.left-area {
  min-width: 248px;
  width: 34.5%;
  float: left;
  background: #fff;
  height: 100vh;
  position: relative;
  z-index: 10;
  box-shadow: darkgrey 0px 0px 14px 0px;
}

.right-area {
  position: relative;
  min-width: 420px;
  width: 65.5%;
  float: left;
  background: #fff;
  height: 100%;
}

.top-area {
  height: 40px;
  background: #efefef;
  width: 100%;
}

.left-area .top-area {
  background: #132f5e;
  color: #fff;
}

.left-area .top-area .tab-area {
  height: 100%;
  width: 90%;
  min-width: 240px;
  margin: 0 auto;
  text-align: center;
}

.tab-area span {
  cursor: pointer;
}

.tab-checked {
  background: #01abac;
  text-align: center;
  position: relative;
  z-index: 2;
}

.tab-checked:after {
  /* padding: 0 20px; */
  display: block;
  width: 100%;
  height: 30px;
  background: #01abac;
  position: relative;
  /* left:-20px; */
  z-index: -2;
  top: -17px;
  content: "";
  border-radius: 0 0 50% 50%;
  /* border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%; */
}

.left-area .top-area span {
  display: inline-block;
  height: 100%;
  line-height: 40px;
  /* padding: 0 20px; */
  min-width: 60px;
  width: 22%;
  position: relative;
  margin-left: 6px;
}

.left-area .top-area span b {
  display: block;
  position: absolute;
  padding: 0 20px;
  width: 100%;
  left: 0px;
  top: 20px;
  font-size: 12px;
  z-index: 10;
  font-weight: 400;
  display: none;
}

.left-area .top-area span.tab-checked b {
  display: block;
}

.list-area {
  margin: 30px 0 0 0;
}

.list-head {
  border-bottom: 1px solid #c1c1c1;
  /* padding-right: 17px;  */
}

.list-head,
.list-body {
  width: 100%;
  font-size: 0;
}

.list-head span,
.list-body span {
  display: inline-block;
  text-align: center;
  font-size: 0;
  padding: 10px 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.list-head span {
  /* text-align: left;
  text-indent: 10px; */
}
.list-head span b,
.list-body span b {
  font-weight: 400;
  font-size: 14px;
  color: #898989;
}

.list-area {
  display: none;
}

.image-area {
  display: block;
}

.list-body {
  height: calc(100vh - 105px);
  overflow-y: auto;
  /* padding-right: 17px; */
}
.list-body li {
}

.list-body li.checked {
  background: rgb(226, 232, 246);
  width: 100%;
}

.list-body li.checked b {
  color: #000;
}

.file-title {
  margin: 20px 0 10px;
  color: #8a8f99;
  line-height: 20px;
}

.file-title b {
  margin-left: 40px;
  margin-right: 2px;
  display: inline-block;
  font-size: 12px;
  font-weight: 400;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  color: #fff;
  background: #898989;
  border-radius: 50%;
}

.left-file-content {
  height: calc((100vh - 147px) / 2);
  width: 100%;
  overflow-y: auto;
}

.left-file-content p.file-checked {
  height: 34px;
  line-height: 34px;
  color: #333;
  background: #efefef;
}
.left-file-content span:hover {
  cursor: pointer;
}
.left-file-content span {
  display: block;
  height: 34px;
  line-height: 34px;
  color: #333;
  width: 98%;
  text-indent: 66px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 右侧 */

.right-area .top-area b {
  font-size: 16px;
  height: 40px;
  line-height: 40px;
  display: block;
  margin-left: 20px;
}

.right-area-inner {
  height: calc(100vh - 40px);
  overflow-y: auto;
}

/* 右侧影像报告单 */

.report-area {
  padding: 20px 60px;
}

.report-area h3 {
  position: relative;
  padding: 10px 0;
  text-align: center;
}

.report-content {
  margin-top: 20px;
  border-top: 1px solid #c1c1c1;
  min-height: 320px;
}

.report-content div {
  min-height: 40px;
  line-height: 1;
  border-bottom: 1px solid #c1c1c1;
  font-size: 0;
  height: auto;
}

.report-content div p {
  min-height: 40px;
  line-height: 40px;
  font-size: 14px;
  height: 100%;
  float: left;
}

.rep-title {
  float: left;
  line-height: 40px;
  min-height: 40px;
  width: 80px;
  text-align: center;
  /* border-right: 1px solid #c1c1c1; */
  color: #8a8f99;
}

.rep-info-1 {
  float: left;
  color: #333;
  border-left: 1px solid #c1c1c1;
  text-indent: 10px;
  width: calc(100% - 80px);
  line-height: 1.5;
  font-size: 12px;
}

.report-content div p.rep-info-3 {
  float: left;
  color: #333;
  min-height: 40px;
  border-right: 1px solid #c1c1c1;
  border-left: 1px solid #c1c1c1;
  text-indent: 10px;
  width: calc((100% - 240px) / 3);
  line-height: 1.5;
  height: 100%;
  font-size: 12px;
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; */
}

.report-content div p.none-left-boder {
  border-left: none;
}

.report-content div p.none-right-boder {
  border-right: none;
}

.rep-button-area {
  position: absolute;
  right: 0;
}

.button {
  font-weight: 400;
  padding: 6px 12px;
  border-radius: 4px;
  color: #fff;
  background: #01abac;
}

.tools-area {
  font-size: 12px;
  position: absolute;
  right: -240px;
  top: 0;
  width: 240px;
  height: 100%;
  background: rgba(10, 25, 49, 0.9);
  color: #8891a2;
}

.open-tools-area {
  cursor: pointer;
  padding: 10px 6px;
  position: absolute;
  top: 180px;
  left: -22px;
  width: 22px;
  color: #fff;
  line-height: 1.5;
  text-align: center;
  border-radius: 6px 0 0 6px;
  background: rgba(10, 25, 49, 0.9);
}

.tools-area h2 {
  text-align: center;
  margin-top: 40px;
}

.tools-area h2 p {
  font-weight: normal;
  margin-top: 16px;
}

.tools-area h2 div {
  font-weight: normal;
  margin-top: 30px;
}

.tools-area h2 p.time {
  font-size: 30px;
  font-weight: 900;
  color: #fff;
}

.time-text {
  color: #fff;
}

.button-size-big {
  padding: 10px 40px;
}

.lesson-area {
  text-align: left;
  margin-top: 40px;
}

.lesson-area p {
  margin-top: 6px;
}

.lesson-title {
  float: left;
  width: 70px;
  text-align: right;
  margin-left: 20px;
  line-height: 1.2;
}

.lesson-content {
  min-height: 30px;
  height: auto;
  line-height: 1.2;
  float: left;
  /* width: calc(100% - 100px); */
  overflow: hidden;

  text-overflow: ellipsis;

  display: -webkit-box;

  -webkit-box-orient: vertical;

  -webkit-line-clamp: 2;
}
.lesson-content b {
  position: relative;
  top: -13px;
}
.stu-avatar {
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 1px solid #fff;
  border-radius: 50%;
  margin-right: -12px;
}

.stu-avatar img {
  width: 24px;
  height: 24px;
}

.stu-avatar-arrow {
  /* margin-right: 10px; */
  display: inline-block;
  height: 30px;
  line-height: 1.2;
  position: absolute;
  right: 16px;
}

.good-area {
  width: 180px;
  margin: 20px auto;
}

.good-area a {
  position: relative;
  border-radius: 4px;
  padding: 10px;
  color: #8891a2;
  background: rgba(0, 0, 0, 0.3);
}

.good-button {
  float: left;
}

.collect-button {
  float: right;
}

.ending-study-area {
  position: absolute;
  bottom: 40px;
  margin-top: 60px;
  text-align: center;
  width: 100%;
}

.ending-study-area a {
  background: #f0a800;
}

/* 右侧病例资料 */

.mr-deital-area {
  padding: 15px;
}

.mr-tabs {
  /* margin-top: 10px; */
}

.mr-tabs span {
  cursor: pointer;
  float: left;
  margin-right: 20px;
  padding: 10px 2px;
}

.mr-tab-checked {
  color: #01abac;
  border-bottom: 2px solid #01abac;
}

.mr-info-content h5 {
  margin: 20px 0;
}

.mr-info-row {
  margin-top: 10px;
}

.mr-info-title {
  float: left;
  width: 80px;
  line-height: 1.5;
  text-align: right;
  color: #8891a2;
}

.mr-info-detail {
  line-height: 1.5;
  float: left;
  width: 268px;
  color: #333;
  height: 30px;
}

.mr-info-detail-1 {
  line-height: 1.5;
  width: 680px;
  margin-left: 80px;
  color: #333;
}

.mr-info-content {
  margin-top: 20px;
}

.mr-info-img-list-head {
  font-size: 0;
  background: #8a8f99;
}

.mr-info-img-list-head span {
  display: inline-block;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  color: #fff;
  text-indent: 20px;
  white-space: nowrap;
}

.mr-info-img-list-body {
  font-size: 0;
}
.mr-info-img-list-body .icon-yuepian {
  color: #00abad;
}

.mr-info-img-list-body span {
  display: inline-block;
  height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 14px;
  text-align: left;
  text-indent: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.background-dark {
  background: #efefef;
}

/* 附件 */

.mr-info-file-area {
  min-height: 200px;
}

.mr-info-file-area > span {
  float: left;
  color: #000;
  line-height: 3;
}

.file-content {
  float: left;
  width: 700px;
}

.item-file {
  width: 100px;
  float: left;
  display: inline;
  margin-left: 20px;
  margin-bottom: 20px;
}

.item-file img {
  width: 100px;
  height: 100px;
  border: 1px solid #efefef;
}

.item-file p {
  margin-top: 6px;
  width: 100px;
  word-wrap: break-word;
  word-break: normal;
  text-overflow: ellipsis;
  color: #8891a2;
}

.paddingRight17 {
  padding-right: 17px;
}

/* 右侧附件 */

.mr-file-area {
  padding: 20px;
  text-align: center;
  height: 90%;
}

.mr-file-iframe {
  width: 100%;
  height: calc(100vh - 90px);
}

.mr-pic {
  border: none;
}

/* 播放 */

.mp4-area {
  min-width: 600px;
  min-height: 300px;
  height: 336px;
  position: fixed;
  left: 20%;
  right: 30%;
  top: 10%;
  bottom: 0;
  z-index: 99;
}

.mp4-head {
  float: left;
  width: 100%;
  height: 26px;
  line-height: 26px;
  background: #40495c;
  color: #fff;
  font-size: 12px;
  text-indent: 10px;
}

.mp4-head i {
  float: right;
  color: #fff;
  font-style: normal;
  font-weight: 900;
  margin-right: 8px;
  cursor: pointer;
}

.mp4-left {
  height: 336px;
  overflow: auto;
  float: left;
  width: 200px;
  min-height: 300px;
  background: #2e3542;
}

.mp4-vedio {
  float: left;
  width: 320px;
}

.mp4-left ul {
  margin-top: 20px;
}

.mp4-left ul li {
  text-indent: 20px;
  height: 30px;
  line-height: 30px;
}

.mp4-left ul li a {
  display: block;
  padding-right: 10px;
  text-indent: 20px;
  color: #6e778a;
  font-size: 12px;
}

.mp4-left ul li b {
  font-weight: 400;
  float: left;
  width: 132px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
}

.mp4-left ul li a span {
  float: right;
}

.mp4-left ul li.play-now b {
  color: #01abac;
}

#close-mp4 {
  font-size: 10px;
  position: relative;
  top: 12px;
}

#coor {
  z-index: 20;
  width: 10px;
  height: 10px;
  overflow: hidden;
  cursor: se-resize;
  position: absolute;
  right: 0;
  bottom: 0;
  /* background-color: #09C; */
}

.mp4-video {
  height: 100%;
}

video {
  object-fit: fill;
  width: calc(100% - 200px);
  height: 100%;
  min-width: 400px;
  min-height: 300px;
}
.p-line2 {
  position: relative;
  line-height: 20px;
  max-height: 40px;
  overflow: hidden;
}
.p-line2::after {
  content: "...";
  position: absolute;
  bottom: 0;
  right: 0;
  padding-left: 40px;
  background: -webkit-linear-gradient(left, transparent, transparent 55%);
  background: -o-linear-gradient(right, transparent, transparent 55%);
  background: -moz-linear-gradient(right, transparent, transparent 55%);
  background: linear-gradient(to right, transparent, transparent 55%);
}
</style>



// WEBPACK FOOTER //
// teachRoom.vue?09c62044